import React from "react";
import { useField, useFormikContext } from "formik";
import AsyncSelect from ".";

interface Props {
  name: string;
  url: string;
  labelKey: string;
  valueKey: string;
  placeholder?: string;
  disabled?: boolean;
  defaultValue?: any;
  params?: Record<string, any>;
  label?: string;
  onChange?: (value: any, item: any) => void;
  isMulti?: boolean;
}

const AsyncSelectFormik: React.FC<Props> = ({
  name,
  label,
  onChange,
  isMulti = false,
  ...rest
}) => {
  const [field] = useField(name);
  const { setFieldValue } = useFormikContext<any>();

  const safeValue = () => {
    if (isMulti) {
      return Array.isArray(field.value) ? field.value : [];
    }
    return field.value !== undefined ? field.value : undefined;
  };

  return (
    <div style={{ marginBottom: 16 }}>
      {label && (
        <label
          htmlFor={name}
          style={{
            display: "block",
            marginBottom: 4,
            color: "var(--text-color)",
          }}
        >
          {label}
        </label>
      )}
      <AsyncSelect
        {...rest}
        defaultValue={safeValue()}
        isMulti={isMulti}
        onChange={(val: any, item: any) => {
          if (isMulti) {
            const ids = Array.isArray(item) ? item.map((el) => el.id) : [];
            setFieldValue(name, ids);
          } else {
            setFieldValue(name, item?.controller_id);
            if (onChange) onChange(val, item);
          }
        }}
      />
    </div>
  );
};

export default AsyncSelectFormik;
